// src/auth/auth.js
import { fetchAuthSession } from "aws-amplify/auth";

/* Returns Cognito ID token string (JWT) */
export const getAuthToken = async () => {
  const session = await fetchAuthSession();
  
  // accessToken replaced with idToken for Bearer authentication
  return session.tokens?.idToken?.toString();
};
